import { useSelector } from 'react-redux';

/**
 * Hook for validating if user has desired permission
 * @param {string} permissionName
 */
const usePermission = (permissionName) => {
  // If permission name is undefined | null allow functionality
  if (!permissionName) {
    return true;
  }

  // Select this data from redux
  const user = useSelector((reduxState) => reduxState.auth.user);

  // Return this fetched data, with reload function, if this function is called reload data happens
  return Boolean(user && user.permissions && user.permissions[permissionName]);
};

export default usePermission;
